<template>
  <div
    class="cart-preview-container"
    :class="brandsCount < 3 ? 'small-preview' : 'big-preview'"
  >
    <RetailerCartPreviewSection :is-loading="isLoading" />
  </div>
</template>

<script setup lang="ts">
import { useCart } from '@monolith/legacy/modules/cart-2/composables/use-cart';
import { onMounted, ref } from 'vue';
import RetailerCartPreviewSection from '@monolith/legacy/components/header/retailer-cart-preview-section.vue';
import { computed } from 'vue';

const { fetchCart, trackCartPreviewViewedWrapper, itemAggregates: regularCartBrandsCount } = useCart();
const isLoading = ref(false);
const brandsCount = computed(() => regularCartBrandsCount.value?.length);

onMounted(async () => {
  isLoading.value = true;
  await fetchCart();
  trackCartPreviewViewedWrapper();
  isLoading.value = false;
});
</script>

<style scoped lang="scss">
.cart-preview-container {
  @apply ds-absolute ds-z-10 ds-top-full ds-right-[-25px] ds-border-solid ds-border ds-border-neutral-200 ds-rounded-b-lg ds-bg-white;
  height: 375px;
  overflow-y: scroll;
}

.small-preview {
  @apply ds-h-[300px];
}

.big-preview {
  @apply ds-h-[375px];
}
</style>
